export const CLERGY_STATUS = [
  { value: "publico", label: "Público" },
  { value: "privado", label: "Privado" },
  { value: "pendente", label: "Pendente" },
  { value: "a_confirmar", label: "A confirmar" },
];

export const PRELACY_FILTERS = [
  "Sé Primacial",
  "Prelazia Anglicana dos Pampas",
  "Prelazia Anglicana Jesus Salvador",
  "Prelazia Anglicana Sagrada Face",
  "Prelazia Anglicana São Jorge Guerreiro",
];

export const CLERGY_GROUPS = [
  {
    title: "Identidade",
    fields: [
      { k: "nome_civil", l: "Nome civil" },
      { k: "nascimento", l: "Nascimento" },
      { k: "naturalidade", l: "Naturalidade" },
      { k: "nacionalidade", l: "Nacionalidade" },
      { k: "vinculacao_religiosa", l: "Vinculação religiosa" },
      { k: "primeiros_votos", l: "Primeiros votos" },
    ],
  },
  {
    title: "Ministério e Ordens",
    fields: [
      { k: "ordenacao_diaconal", l: "Ordenação diaconal" },
      { k: "ordenacao_presbiteral", l: "Ordenação presbiteral" },
      { k: "sagracao_episcopal", l: "Sagração episcopal" },
      { k: "local_ordenacoes", l: "Local das ordenações" },
      { k: "local_sagracao", l: "Local da sagração episcopal" },
      { k: "bispo_ordenante", l: "Bispo ordenante" },
      { k: "bispos_consagrantes", l: "Bispos consagrantes" },
      { k: "recepcao_dacb", l: "Recepção na DACB" },
      { k: "incardinacao_dacb", l: "Incardinação na DACB" },
      { k: "transferencia", l: "Transferência entre prelazias" },
      { k: "situacao_canonica", l: "Situação canônica" },
    ],
  },
  {
    title: "Contato e Pastoral",
    fields: [
      { k: "whatsapp", l: "WhatsApp" },
      { k: "telefone", l: "Telefone" },
      { k: "email", l: "E-mail" },
      { k: "endereco_pastoral", l: "Endereço pastoral" },
      { k: "cep", l: "CEP" },
      { k: "atendimento", l: "Atendimento pastoral" },
      { k: "celebracoes", l: "Dias e horários de celebração" },
    ],
  },
];

export const CLERGY_CORE_FIELDS = [
  { k: "titulo", l: "Título", core: true },
  { k: "nome", l: "Nome eclesiástico", core: true },
  { k: "cargo", l: "Cargo/Função", core: true },
  { k: "prelazia", l: "Prelazia/Jurisdição", core: true },
  { k: "comunidade", l: "Paróquia/Comunidade", core: true },
  { k: "cidade", l: "Cidade", core: true },
  { k: "uf", l: "UF", core: true },
];

export const CLERGY_EMPTY = {
  titulo: "Rev. Pe.",
  nome: "",
  nome_civil: "",
  cargo: "Presbítero",
  prelazia: "",
  comunidade: "",
  cidade: "",
  uf: "",
  nascimento: "",
  naturalidade: "",
  nacionalidade: "",
  vinculacao_religiosa: "",
  primeiros_votos: "",
  ordenacao_diaconal: "",
  ordenacao_presbiteral: "",
  sagracao_episcopal: "",
  local_ordenacoes: "",
  local_sagracao: "",
  bispo_ordenante: "",
  bispos_consagrantes: "",
  recepcao_dacb: "",
  incardinacao_dacb: "",
  transferencia: "",
  whatsapp: "",
  telefone: "",
  email: "",
  endereco_pastoral: "",
  cep: "",
  atendimento: "",
  celebracoes: "",
  situacao_canonica: "",
  biografia: "",
  foto: "",
  galeria: [],
  observacoes_internas: "",
  field_status: {},
  ativo: true,
};
